import Super from 'client-portal/routes/-request/channel-fields';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetChannelFields extends Super {}
